import { Grid } from '@mui/material';
import faqPDF from '../../../static/resources/wallet-faq.pdf';
import './builder-faq.scss';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import PDFViewer from '../Common/PDFViewer';

const FAQ = () => (
    <Grid
        container
        backgroundColor="dark.main"
        className="info-card-container-dashboard"
    >
        <PDFViewer PDF={faqPDF} />
    </Grid>
);
export default FAQ;
